// Vendor
import * as React from 'react';
import { Image } from '@src/components/Image/Image';

const Foreword: React.FC = () => {
  const classesParagraph = 'tup-body';

  return (
    <div className="tup-slide">
      <h1>Foreword</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 md:gap-8">
        <div>
          <p className={classesParagraph}>
            We were just days from publishing our 2020 Resale Report in March
            when the Covid crisis hit.
          </p>

          <p className={classesParagraph}>
            Like every business in the world, thredUP paused to focus on the
            safety of our teams and set a plan for the rest of 2020. At the
            time, it seemed that Covid had “changed everything.” But is that
            really true as we look ahead? Here’s what the latest data is telling
            us:
          </p>

          <p className={classesParagraph}>
            First, changes that were already afoot in retail are accelerating
            rapidly. Sheltering in place catalyzed the shift toward shopping
            online. As a result, opportunities are expanding for the strongest
            ecommerce and marketplace businesses.
          </p>

          <p className={classesParagraph}>
            Second, for all the challenges Covid posed to our assumptions about
            consumer behavior, one thing is clear: consumers everywhere are
            prioritizing value and accelerating the shift to thrift. When times
            get uncertain, we all focus on our family balance sheet. Brands
            whose core proposition delivers value and convenience have the
            opportunity to gain share. Amazon, off-price, and resale are
            emerging as winners.
          </p>
        </div>
        <div>
          <p className={classesParagraph}>
            Finally, the youth of the world are more switched on than ever about
            the health of the planet. With their words, deeds, and dollars, the
            younger generation is demonstrating a genuine desire to be part of
            the long-term solution to fashion waste. This should inspire much
            optimism in all of us. The consciousness of the next generation of
            consumers is a tailwind for businesses that deliver customer value
            in a sustainable way.
          </p>

          <p className={classesParagraph}>
            This year’s Resale Report, unlike any we’ve published, captures
            insights from two different consumer worlds: pre- and post-Covid. We
            hope it sparks rich dialogue about the enduring shifts underway and
            the forces fueling the future of resale.
          </p>
          <Image
            alt="Anthony Marino Signature"
            fileName="asm-signature.jpg"
            maxWidth={240}
          />
          <p className={classesParagraph}>
            <b className="uppercase tracking-wider">– Anthony S. Marino</b>
            <br />
            President, thredUP
          </p>
        </div>
      </div>
    </div>
  );
};

export { Foreword };
